/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.partner.demo.rpc.PartnerDemoHubValidationRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const validateHubsRpc = {
  serviceName: 'com.hubspot.partner.demo.rpc.PartnerDemoHubValidationRpc',
  rpcName: 'validateHubs',
  auth: 'app',
  fingerprint: 'BHtbQgAAC-1H3fokfNdpKpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: true
};